const CappedArrayPlugin = {
  install(app) {
    const applyCap = (array, limit) => {
      if (array.length > limit) {
        array.splice(0, array.length - limit);
      }
    };

    app.config.globalProperties.$pushToCappedArray = (array, limit, ...items) => {
      array.push(...items);
      applyCap(array, limit);
    };

    app.config.globalProperties.$concatToCappedArray = (array, limit, newItems) => {
      array.push(...newItems);
      applyCap(array, limit);
    };

    app.config.globalProperties.$batchCappedArray = (array, batchSize) => {
      return array.splice(0, batchSize);
    };

    app.config.globalProperties.$restoreToCappedArray = (array, limit, failedBatch) => {
      array.unshift(...failedBatch);
      applyCap(array, limit);
    };
  }
};
export default CappedArrayPlugin;
